const state = () => ({
    list: [],
    loading: false
})

const getters = {}

const actions = {
    async get({commit}) {
        commit('setLoading', true)
        try {
            const res = await this._vm.axios.get(this._vm.endpoints['module_note_tag'])
            const {data} = res.data
            commit('setList', data || [])
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        } finally {
            commit('setLoading', false)
        }
    },

    async add({commit, dispatch}, {formData}) {
        try {
            const res = await this._vm.axios.post(this._vm.endpoints['module_note_tag'], {
                name: formData.name,
            })
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    async update({commit, dispatch}, {id, formData}) {
        try {
            const res = await this._vm.axios.put(this._vm.endpoints['module_note_tag'] + '/' + id, {
                name: formData.name,
            })
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    async delete({commit, dispatch}, {id}) {
        try {
            const res = await this._vm.axios.delete(this._vm.endpoints['module_note_tag'] + '/' + id)
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },
}

const mutations = {
    setLoading(state, val) {
        state.loading = val
    },
    setList(state, data) {
        state.list = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
